import React, { useEffect } from 'react';
import { DescriptionContainer, DescriptionTextArea, FileName, FileNameContainer, ShieldIcon, TileView, TileWrapper } from './style';
import { DESCRIPTION_DEFAULT_PLACEHOLDER, DESCRIPTION_MAX_LENGTH } from './constants';
import { SmallTile } from './SmallTile';
const NO_DESCRIPTION_PLACEHOLDER = '';
const translateString = (key, translateFn) => translateFn ? translateFn(key) : key;
const getDescriptionPlaceholder = (isShared, shouldAllowEditDescription, translateFn) => {
    if (shouldAllowEditDescription || (shouldAllowEditDescription === undefined && !isShared)) {
        return translateString(DESCRIPTION_DEFAULT_PLACEHOLDER, translateFn);
    }
    return NO_DESCRIPTION_PLACEHOLDER;
};
const shouldDisableDescription = (isShared, isSelectModeOn, shouldAllowEditDescription) => {
    if (isSelectModeOn) {
        return true;
    }
    if (shouldAllowEditDescription !== undefined) {
        return !shouldAllowEditDescription;
    }
    return isShared;
};
export const LargeTile = (props) => {
    const [descriptionText, setDescriptionText] = React.useState('');
    useEffect(() => {
        setDescriptionText(props.description || '');
    }, [props.description]);
    const handleDescriptionChange = (event) => {
        setDescriptionText(event.target.value);
    };
    const handleDescriptionBlur = (event) => {
        if (props.onUpdateDescription) {
            props.onUpdateDescription(props.id, event.target.value);
        }
    };
    const renderInsuranceShield = () => props.isReceived ? (React.createElement(ShieldIcon, { id: `tile-shield-${props.index}`, isShared: true, className: "mi-icon-insurance-shield-received" })) : props.isSent ? (React.createElement(ShieldIcon, { id: `tile-shield-${props.index}`, isShared: true, className: "mi-icon-insurance-shield-sent" })) : props.isShareable ? (React.createElement(ShieldIcon, { id: `tile-shield-${props.index}`, isShared: false, className: "mi-icon-insurance-shield" })) : (React.createElement(React.Fragment, null));
    const description = (React.createElement(DescriptionContainer, null,
        React.createElement(DescriptionTextArea, { id: `tile-description-${props.index}`, value: descriptionText, maxLength: DESCRIPTION_MAX_LENGTH, placeholder: getDescriptionPlaceholder(props.isShared, props.shouldAllowEditDescription, props.translateFn), disabled: shouldDisableDescription(props.isShared, props.isSelectModeOn, props.shouldAllowEditDescription), shouldAllowEditDescription: props.shouldAllowEditDescription, isShared: props.isShared, onChange: handleDescriptionChange, onBlur: handleDescriptionBlur })));
    return (React.createElement(TileWrapper, { id: `large-tile-wrapper-${props.index}`, selected: props.isSelected },
        React.createElement(TileView, { id: `large-tile-view-${props.index}` },
            React.createElement(FileNameContainer, null,
                renderInsuranceShield(),
                React.createElement(FileName, { id: `tile-filename-${props.index}` }, props.fileName)),
            React.createElement(SmallTile, Object.assign({}, props, { onTileClick: props.onTileClick, height: props.height, width: props.width, style: { border: '0', padding: '0' }, shouldShowThumbnailForPdf: props.shouldShowThumbnailForPdf, labelValue: "" // label is not needed for large tile as it is shown below the description
             })),
            description,
            props.labelValue && React.createElement("p", null, props.labelValue))));
};
//# sourceMappingURL=LargeTile.js.map